import React from "react";
import StrategyVideo from "../assets/video/4sec.mp4";

const Process = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-20">
          <h6 className="text-[#69A41D] text-[14px] md:text-[16px] font-medium uppercase mb-3">
            Work Process
          </h6>

          <h2 className="text-[32px] md:text-[40px] font-semibold text-[#18443A] leading-tight">
            Empowering Businesses with
            <br />
            Sustainable Packaging
          </h2>

          <p className="text-slate-500 text-[16px] mt-6 max-w-2xl mx-auto leading-8">
            Delivering excellence, durability, and sustainable packaging
            solutions trusted by industries worldwide.
          </p>
        </div>

        {/* Process Timeline */}
        <div className="max-w-6xl mx-auto space-y-24">
          {/* STEP 1 */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="flex justify-center">
              <video
                src={StrategyVideo}
                className="w-full max-w-[520px] aspect-video object-cover rounded-2xl shadow-xl"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            <div>
              <div className="flex items-center gap-4 mb-5">
                <div className="w-14 h-14 rounded-full bg-[#18443A] text-white flex items-center justify-center font-bold text-lg shadow-lg">
                  1
                </div>

                <h3 className="text-[30px] font-semibold text-[#18443A]">
                  Step 1
                </h3>
              </div>

              <p className="text-slate-500 text-[16px] leading-8">
                Our mission is to provide high-quality, reliable, and
                sustainable wooden packaging solutions that exceed customer
                expectations and meet global industry standards.
              </p>
            </div>
          </div>

          {/* STEP 2 */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="md:order-1 order-2 text-left md:text-right">
              <div className="flex md:justify-end items-center gap-4 mb-5">
                <h3 className="text-[30px] font-semibold text-[#18443A]">
                  Step 2
                </h3>

                <div className="w-14 h-14 rounded-full bg-[#18443A] text-white flex items-center justify-center font-bold text-lg shadow-lg">
                  2
                </div>
              </div>

              <p className="text-slate-500 text-[16px] leading-8">
                We design durable export-grade packaging with precision,
                compliance, and long-lasting structural integrity.
              </p>
            </div>

            <div className="md:order-2 order-1 flex justify-center">
              <video
                src={StrategyVideo}
                className="w-full max-w-[520px] aspect-video object-cover rounded-2xl shadow-xl"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
          </div>

          {/* STEP 3 */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="flex justify-center">
              <video
                src={StrategyVideo}
                className="w-full max-w-[520px] aspect-video object-cover rounded-2xl shadow-xl"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            <div>
              <div className="flex items-center gap-4 mb-5">
                <div className="w-14 h-14 rounded-full bg-[#18443A] text-white flex items-center justify-center font-bold text-lg shadow-lg">
                  3
                </div>

                <h3 className="text-[30px] font-semibold text-[#18443A]">
                  Step 3
                </h3>
              </div>

              <p className="text-slate-500 text-[16px] leading-8">
                Our quality control process ensures every packaging product
                delivers maximum protection and reliability during transit.
              </p>
            </div>
          </div>

          {/* STEP 4 */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="md:order-1 order-2 text-left md:text-right">
              <div className="flex md:justify-end items-center gap-4 mb-5">
                <h3 className="text-[30px] font-semibold text-[#18443A]">
                  Step 4
                </h3>

                <div className="w-14 h-14 rounded-full bg-[#18443A] text-white flex items-center justify-center font-bold text-lg shadow-lg">
                  4
                </div>
              </div>

              <p className="text-slate-500 text-[16px] leading-8">
                We provide customized solutions tailored for industrial,
                logistics, export, and heavy machinery packaging requirements.
              </p>
            </div>

            <div className="md:order-2 order-1 flex justify-center">
              <video
                src={StrategyVideo}
                className="w-full max-w-[520px] aspect-video object-cover rounded-2xl shadow-xl"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
          </div>

          {/* STEP 5 */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="flex justify-center">
              <video
                src={StrategyVideo}
                className="w-full max-w-[520px] aspect-video object-cover rounded-2xl shadow-xl"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>

            <div>
              <div className="flex items-center gap-4 mb-5">
                <div className="w-14 h-14 rounded-full bg-[#18443A] text-white flex items-center justify-center font-bold text-lg shadow-lg">
                  5
                </div>

                <h3 className="text-[30px] font-semibold text-[#18443A]">
                  Step 5
                </h3>
              </div>

              <p className="text-slate-500 text-[16px] leading-8">
                Our commitment to innovation and sustainability helps businesses
                achieve safe, efficient, and eco-friendly packaging operations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
